import { ApiClient } from "@/services/apiClient";
import { ShippingMethod_Schema } from "@/services/marketplace/shippingMethod/shippingMethodSchema";
import { type ShippingMethod } from "@/services/marketplace/shippingMethod/shippingMethodTypes";
import { z } from "zod";

const ApiResponse_ShippingsList_Schema = z.object({ deliveries: ShippingMethod_Schema.array() });
type ApiResponse_ShippingsList = z.infer<typeof ApiResponse_ShippingsList_Schema>;

export const fetchShippingMethods = async (): Promise<ShippingMethod[]> => {
  const url = "api-public/delivery/delivery";
  return ApiClient.getPublic<ApiResponse_ShippingsList>(url).then(({ data }) => ApiResponse_ShippingsList_Schema.parse(data).deliveries);
};
